import { IAction, IOutput, EOutputScope } from '../helpers';

export const DEFAULT_ACTION:IAction = {
    ComponentId: '',
    ActionType: null,
    Properties: [],
    OutputValues: []
};

export const DEFAULT_ACTION_OUTPUT:IOutput = {
    Id: '',
    Name: '',
    Type: 1,
    GlobalOutputId: '',
    LogicalName: '', 
    IsRequiredGlobalOutput: false,
    DisablePrepopulatedValue: false, 
    OutputScope: EOutputScope.Local
};


// WEBPACK FOOTER //
// ./source/ts/constants/actions.ts